module.exports = __webpack_public_path__ + "static/img/kapelusz_g.b475a70c.webp";